<template>
  <div>
    <v-card class="reset">
      <v-card-title>
        {{ $t('pages.resetpassword.title') }}
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="submit()">
          <component
            v-for="input in inputs"
            :key="input.key"
            :is="input.component"
            :config="input"
            v-model="form[input.key]">
          </component>
          <v-btn
            v-if="error.reset_password_token"
            block outline primary light
            router :href="{ name: 'ForgotPassword' }">
            {{ $t('pages.resetpassword.forgot') }}
          </v-btn>
          <v-btn
            type="submit"
            primary light block ripple
            :loading="loading">
            {{ $t('pages.resetpassword.submit') }}
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-snackbar error v-model="error.reset_password_token" multi-line>{{ $t('pages.resetpassword.passwordTokenError') }}</v-snackbar>
    <v-btn block flat light router :href="{ name: 'Login' }">{{ $t('pages.resetpassword.login') }}</v-btn>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { TextInput } from '@/components/inputs'
  export default {
    props: {
      platformName: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        error: {},
        form: {
          email: null
        }
      }
    },
    computed: {
      ...mapGetters({
        loading: 'skiliko/password/isLoading'
      }),
      inputs () {
        return [
          { key: 'password', required: true, component: TextInput, type: 'password' },
          { key: 'confirmation', required: true, component: TextInput, type: 'password' }
        ]
          .map(input => {
            const data = { terms: this.terms, privacy: this.privacy }
            return {
              ...input,
              label: this.$t(`pages.resetpassword.labels.${input.key}`, data),
              errors: (this.error[input.key] || []).map(e => () => e)
            }
          })
      }
    },
    methods: {
      ...mapActions({
        reset: 'skiliko/password/reset'
      }),
      submit () {
        this.reset({
          token: this.token,
          password: this.form.password,
          passwordConfirmation: this.form.confirmation,
          platformName: this.platformName
        })
          .then(_ => this.$router.replace({ path: this.$route.query.redirect || '/' }))
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .reset {
    width: 350px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue